import React from 'react';

import {
  TabContext,
  TabPanel
} from '@mui/lab';
import {
  Box,
  FormControlLabel,
  Grid,
  Stack,
  styled,
  Switch
} from '@mui/material';
import _ from 'lodash';
import {
  LoadingBox,
  TabBar
} from 'modules';

import { TermAccordion } from './components/TermAccordion';
import * as dataService from './dataService';



const TabPanelControllerBox = styled(Box)({
  width: '100%',
  display: 'flex',
  justifyContent: 'space-between'
});



interface IProps {}

export const LegalTerms: React.FC<IProps> = props => {
  const { loading, data } = dataService.useTermsCollection();

  const [activeTab, setActiveTab] = React.useState<dataService.ITabName>('equity');
  const [isExpanded, setIsExpanded] = React.useState(false);



  return (
    <Box width='80%'>
      <TabContext value={activeTab}>
        <TabPanelControllerBox>
          <Stack direction='row' spacing={2}>
            <TabBar.FC
              selectedTabId={activeTab}
              tabs={[
                {
                  id: 'equity',
                  label: 'Equity'
                },
                {
                  id: 'convertibleDebt',
                  label: 'Convertible Debt'
                }
              ]}
              onClickTab={setActiveTab} />

          </Stack>

          <FormControlLabel
            control={<Switch />}
            onChange={(_, checked) => setIsExpanded(checked)}
            label='Expand All'
            labelPlacement='start'/>
        </TabPanelControllerBox>

        {_.map(['equity', 'convertibleDebt'], (tabName: dataService.ITabName) => (
          <TabPanel value={tabName} key={tabName} sx={{ paddingLeft: 0, paddingRight: 0 }}>
            <Grid container spacing={4}>
              <LoadingBox.FC active={loading} />
              {!loading && _.map(data[tabName], d => (
                <Grid item xs={3} key={d.id}>
                  <TermAccordion
                    isExpanded={isExpanded}
                    title={d.title}
                    content={d.bodyText}
                  />
                </Grid>
              ))}
            </Grid>
          </TabPanel>
        ))}
      </TabContext>
    </Box>
  );
};
